import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionsService } from 'src/app/subscriptions/subscriptions/services/subscriptions.service';
import { AuthService } from '../../msal/auth.service';
import { CommonService } from '../../services/common.service';
import { SearchUpdateConfirmationComponent } from '../search-update-confirmation/search-update-confirmation.component';

@Component({
  selector: 'app-subscription-sub-menu',
  templateUrl: './subscription-sub-menu.component.html',
  styleUrls: ['./subscription-sub-menu.component.scss']
})
export class SubscriptionSubMenuComponent implements OnInit {
  @Output() closeSidebarHeader = new EventEmitter<any>();
  public url: string = '';
  public isLOBUser: boolean = false;
  @ViewChild('changeMenuModal', {static: true})
  public changeMenuModal: SearchUpdateConfirmationComponent | any;
  menu: string = '';
  constructor(
    private subscriptionsService : SubscriptionsService,
    private router: Router,
    private authService: AuthService, 
    private commonService: CommonService
  ) {
    setTimeout(() => {
    this.authService.subscribeToUrl((url: any) => {
      this.url = url;
    })
    },0);
   }


   //return the selected menu
  get selectedMenu(): string {
    return this.subscriptionsService.selectedMenu;
  }

  ngOnInit(): void {
    this.subscriptionsService.updateSelectedMenu('youtube-sub');
    this.isLOBUser = this.commonService.isLOBUser();
    if(sessionStorage.getItem('currentUrl'))
      {
        this.url = sessionStorage.getItem('currentUrl') as string;        
      }
  }


  /**
   * check if the menu is selected or not
   * @param menuItem 
   * @return boolean
   */

   public isMenuSelected(menuItem: string): boolean {
    return this.selectedMenu === menuItem;
  }


   /**
   * update the selected menu
   * @param menuItem 
   */
  
  public selectMenu(menuItem: string): void {
    this.menu = menuItem;
    if (this.commonService.getFormUpdateStatus()) {
      this.changeMenuModal.showModal();
    } else {
      this.selectMenuConfirmation();
    }
  }

    /** select Menu confirmation popup event */
  selectMenuConfirmation() {
    this.commonService.setFormUpdateStatus(false);
    this.subscriptionsService.updateSelectedMenu(this.menu);
    this.closeSidebarHeader.emit(true);
    sessionStorage.setItem('activeUrl', '/portal/subscriptions/' + this.menu)
    this.router.navigate(['/portal/subscriptions/' + this.menu])
  }

}
